import { Box, CssBaseline } from '@mui/material';
import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { Footer } from './components';
import AppBarMain from './layouts/AppBar/AppBar';

export default function Content() {
  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <CssBaseline enableColorScheme />
      <AppBarMain title={appInfo.title} />
      <Box sx={{ pt: { xs: 35, sm: 20, md: 15 } }}>
        {
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            <Route path='*' element={<Navigate to='/home' />} />
          </Routes>
        }
      </Box>

      <Footer />
    </Box>
  );
}

/*

    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path='*' element={<Navigate to='/home' />} />
      </Routes>

      <Footer />
    </SideNavBarLayout>

*/
